import * as React from 'react';

import * as Autosuggest from 'react-autosuggest';
// import { TextFieldProps } from '@material-ui/core/TextField';
import { ChangeEvent, InputProps } from 'react-autosuggest';
import { SyntheticEvent, useCallback, useState } from 'react';
import { SuggestionsFetchRequestedParams } from 'react-autosuggest';
const match = require('autosuggest-highlight/match');
const parse = require('autosuggest-highlight/parse');
import { GoogleGeocoder, SimpleGeocodeResult } from '../services/geo/geocoder';
import { SuggestionSelectedEventData } from 'react-autosuggest';
import { RenderSuggestionsContainerParams } from 'react-autosuggest';
import { MenuItem, Paper, Theme } from '@material-ui/core';
import { RenderSuggestionParams } from 'react-autosuggest';
import Typography from '@material-ui/core/Typography';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles from '@material-ui/core/styles/withStyles';

interface AutoSuggestGeocoderProps { // extends TextFieldProps {
    country?: string;
    value?: string | undefined;
    onSelect: (selection: SimpleGeocodeResult) => void;
    textFieldProps: TextFieldProps;
    theme: any;
    classes?: any;
    // children: ReactNode;
}

type LocationSuggestion = SimpleGeocodeResult;

const styles = (theme: Theme) =>
    createStyles({
        // container: {
        //     // flexGrow: 1,
        //     position: 'relative'
        // },
        suggestionsContainerOpen: {
            position: 'absolute',
            zIndex: 1,
            // marginTop: theme.spacing(1),
            left: 0,
            // right: 0,
            top: 70
        },
        // suggestion: {
        //     display: 'block',
        //     marginBottom: 0
        // },
        suggestionsList: {
            margin: 0,
            padding: 0,
            listStyleType: 'none'
        },
        // inputContainer: {
        //     paddingTop: theme.spacing(1),
        //     paddingBottom: theme.spacing(1),
        //     paddingRight: theme.spacing(1), // IconButton on right provides sufficient padding
        //     paddingLeft: theme.spacing(2),
        //     backgroundColor: alpha(theme.palette.background.paper, 0.9),
        //     overflow: 'hidden',
        //     '&:hover,&:active,&.inputContainerFocused': {
        //         backgroundColor: theme.palette.background.paper
        //     },
        //     // Maintain a consistent height when IconButton (CancelIcon) is visible.
        //     minHeight: '64px',
        //     display: 'flex',
        //     flexDirection: 'column',
        //     justifyContent: 'center'
        //     //...
        // },
        // grow: {
        //     flexGrow: 1
        // },
        // shrink: {
        //     flexShrink: 1
        // },
        // noGrow: {
        //     flexGrow: 0
        // },
        // noShrink: {
        //     flexShrink: 0
        // }
    });

const geocoder = new GoogleGeocoder();

/** Adapted from https://github.com/wheredoesyourmindgo/react-mui-mapbox-geocoder/blob/master/src/MatGeocoder/MatGeocoder.tsx */
function AutoSuggestGeocoder(props: AutoSuggestGeocoderProps) {
    const [results, setResults] = useState<SimpleGeocodeResult[]>([]);
    const [value, setValue] = useState<string>(props.value || '');

    const renderInput = useCallback((renderInputProps: InputProps<LocationSuggestion>): React.ReactNode => {
        const {classes, ref, inputClasses, onChange, ...other} = renderInputProps;
        // console.info('renderInput:', renderInputProps);

        function _onChange(event: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) {
            // console.info('onChange:', event, arguments);
            onChange(event, {newValue: event.currentTarget.value, method: 'type'});
        }

        // return props.children;
        return (
            <TextField
                InputProps={{
                    inputRef: ref,
                    classes: inputClasses,
                    onChange: _onChange,
                    ...other
                }}
                {...props.textFieldProps}
            />
        );
    }, [value]);

    function handleSuggestionsFetchRequested(suggestion: SuggestionsFetchRequestedParams) {
        console.info('handleSuggestionsFetchRequested:', suggestion);

        if (suggestion.value === '') {
            setResults([]);
        } else {
            geocoder.geocode(suggestion.value, props.country, 3600000).then(geocodeResults => {
                setResults(geocodeResults);
            }).catch(err => {
                console.error(err);
            });
        }
    }

    function handleSuggestionsClearRequested() {
        setResults([]);
    }

    function handleChange(event: React.FormEvent<any>, {newValue}: ChangeEvent) {
        // console.info('handleChange:', newValue);
        setValue(newValue);
    }

    function handleSuggestionSelected(event: React.FormEvent<any>, data: SuggestionSelectedEventData<LocationSuggestion>) {
        // console.info('selected geocoded result:', data);
        props.onSelect(data.suggestion);
    }
    
    function renderSuggestionsContainer(params: RenderSuggestionsContainerParams): React.ReactNode {
        // console.info('renderSuggestionsContainer:', params);
        const {containerProps, children} = params;
        // {/*{...suggestionsPaperProps}*/}
        return (
            <Paper
                {...containerProps}
                square={false}
                elevation={4}
            >
                {children}
            </Paper>
        );
    }

    function getSuggestionValue(suggestion: LocationSuggestion): string {
        return suggestion.location.suburb + ', ' + suggestion.location.state;
    }
    
    function renderSuggestion(suggestion: LocationSuggestion, {query, isHighlighted}: RenderSuggestionParams): React.ReactNode {
        const matches = match(suggestion.formatted_address, query);
        const parts = parse(suggestion.formatted_address, matches);

        return (
            <MenuItem selected={isHighlighted} component="div">
                <Typography noWrap variant="subtitle1">
                    {parts.map(
                        (part: {highlight: boolean; text: string}, index: number) => {
                            return <span key={String(index)} style={{fontWeight: part.highlight ? 'bold' : 'normal'}}>{part.text}</span>;
                        }
                    )}
                </Typography>
            </MenuItem>
        );
    }

    return (
        // function shouldRenderSuggestions(value) {
        //     return value.trim().length > 2;
        // }

        <Autosuggest
            theme={{
                container: props.theme.container, // {...props.classes.container, ...props.theme.container},
                suggestionsContainerOpen: props.classes.suggestionsContainerOpen,
                suggestionsList: props.classes.suggestionsList,
            // //     suggestion: classes.suggestion
            }}
            renderInputComponent={renderInput}
            suggestions={results}
            onSuggestionsFetchRequested={handleSuggestionsFetchRequested}
            onSuggestionsClearRequested={handleSuggestionsClearRequested}
            onSuggestionSelected={handleSuggestionSelected}
            renderSuggestionsContainer={renderSuggestionsContainer}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={{
            //     classes,
            //     placeholder: inputPlaceholder,
                value: value,
                onChange: handleChange,
            //     onFocus: focusInputHandler,
            //     onBlur: blurInputHandler,
            //     inputClasses
            }}

            // highlightFirstSuggestion
        />
    );
}

export default withStyles(styles)(AutoSuggestGeocoder);
